import React from 'react';

// sem isso, qualquer erro na remontagem (voltar ao app depois do Android
// descarregar a aba) derruba a arvore inteira e sobra tela branca
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erro: null };
  }
  static getDerivedStateFromError(erro) {
    return { erro };
  }
  componentDidCatch(erro, info) {
    console.error('ClawETF quebrou:', erro, info);
  }
  render() {
    if (!this.state.erro) return this.props.children;
    return (
      <div style={{padding:20, fontFamily:'system-ui', backgroundColor:'#0f172a', color:'#e2e8f0', minHeight:'100vh'}}>
        <h2 style={{color:'#ef4444', fontSize:18}}>⚠️ Algo quebrou</h2>
        <p style={{fontSize:13, color:'#9ca3af'}}>Toque para recarregar. Se puder, me mande a mensagem abaixo.</p>
        <button onClick={() => window.location.reload()}
          style={{padding:'10px 16px', backgroundColor:'#6366f1', color:'#fff', border:'none', borderRadius:8, fontSize:14, marginBottom:16}}>
          Recarregar
        </button>
        <pre style={{fontSize:10, color:'#6b7280', whiteSpace:'pre-wrap', wordBreak:'break-word'}}>
          {String((this.state.erro && this.state.erro.stack) || this.state.erro)}
        </pre>
      </div>
    );
  }
}
